import React, { useContext } from "react";
import { MixtureListChooseStyled } from "./MixtureListChooseStyled";
import {
  MixtureChooseEnum,
  MixtureChooseOptions,
} from "../../../entities/Mixture";
import { TranslationContext } from "../../../context/TranslationContext";
import { TranslationContextInterface } from "../../../entities/Language";
import { getValueForKey } from "../../../context/translationsUtils";
import { useSelector } from "react-redux";
import { getDataFromMixture } from "../../Mixture/selectors";
import { useAppDispatch } from "../../../store/store";
import { getCalculatedVolume } from "../../Calculation/slice/selectors";
import { TEST_ID } from "../../../shared/testid";
import { getCalculatedRatioForCondiments } from "../../Mixture/actions";
import Skeleton from "react-loading-skeleton";

const MixtureListChoose: React.FC = () => {
  const { mixtureOption, selectedWeight, condiments, mixtureIsLoading } =
    useSelector(getDataFromMixture);
  const { minVolumeOfMix: minWeight, maxVolumeOfMix: maxWeight } =
    useSelector(getCalculatedVolume);
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const dispatch = useAppDispatch();

  const handleSwitchMixtureOption = (option: MixtureChooseEnum) => {
    dispatch(
      getCalculatedRatioForCondiments({
        data: {
          condiments: condiments.map((item) => ({
            ...item,
            ...item.meta,
          })),
          weight: selectedWeight,
          receipeType: mixtureOption,
        },
        nextMixtureOption: option,
      }),
    );
  };

  if (minWeight === 0 || maxWeight === 0) {
    return null;
  }

  return (
    <MixtureListChooseStyled>
      <div className="mixture-instruction">
        {getValueForKey(translations, "edit_mix.step_0_hint")}
      </div>
      <div
        className={`mixture-choose__items ${
          mixtureIsLoading ? "is-loading" : ""
        }`}
      >
        {MixtureChooseOptions.map((option) => (
          <button
            key={option}
            onClick={() => handleSwitchMixtureOption(option)}
            className={`mixture-choose__item ${
              mixtureOption === option ? "active" : ""
            }`}
            data-testid={`${TEST_ID.CREATE_MIX.MIXTURE_TYPE}-${option}`}
          >
            <div className="mixture-choose__icon"></div>
            {mixtureIsLoading ? (
              <Skeleton width={60} height={22}></Skeleton>
            ) : (
              <span>
                {getValueForKey(translations, `edit_mix.mix_option_${option}`)}
              </span>
            )}
          </button>
        ))}
      </div>
    </MixtureListChooseStyled>
  );
};

export default MixtureListChoose;
